import { render, staticRenderFns } from "./DisputeResolvePurchaseInvoiceModal.vue?vue&type=template&id=226d462f&scoped=true&"
import script from "./DisputeResolvePurchaseInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./DisputeResolvePurchaseInvoiceModal.vue?vue&type=script&lang=js&"
import style0 from "./DisputeResolvePurchaseInvoiceModal.vue?vue&type=style&index=0&id=226d462f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226d462f",
  null
  
)

export default component.exports